import React, { useRef, useCallback, useState } from 'react'
import styles from './image-box.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const ImageBox = ({
  classes,
  className,
  onImgClick,
  imageClassName,
  src,
  alt,
  fill
}) => {
  const containerRef = useRef(null)
  const imgRef = useRef(null)

  const [styles, setStyles] = useState({
    opacity: '0',
    transition: 'opacity 0.3s'
  })

  const onLoad = useCallback(() => {
    const containerAspectRatio =
      containerRef.current.offsetWidth / containerRef.current.offsetHeight
    const imgAspectRatio =
      imgRef.current.offsetWidth / imgRef.current.offsetHeight
    setStyles(
      containerAspectRatio < imgAspectRatio
        ? {
            ...styles,
            width: '100%',
            height: 'auto',
            opacity: '1'
          }
        : {
            ...styles,
            width: 'auto',
            height: '100%',
            opacity: '1'
          }
    )
  }, [imgRef, containerRef, styles])

  return (
    <div
      onClick={fill ? onImgClick : null}
      ref={containerRef}
      style={!fill ? null : { backgroundImage: `url("${src}")` }}
      className={classNames(classes.container, className, {
        [classes.clickable]: !!onImgClick
      })}>
      {!fill && (
        <img
          onClick={onImgClick ? onImgClick : null}
          ref={imgRef}
          className={classNames(classes.image, imageClassName)}
          style={styles}
          src={src}
          alt={alt}
          onLoad={onLoad}
        />
      )}
    </div>
  )
}

export default injectSheet(styles)(ImageBox)
